import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({ selector: "[OnlyCharacters]" })
export class OnlyCharactersDirective {
  constructor(private hostElement: ElementRef) {}

  @HostListener("input") onInput() {
    const value = this.hostElement.nativeElement.value;
    const charValue = value.replace(/[^a-zA-Z\s]/g, "");

    if (value !== charValue) {
      this.hostElement.nativeElement.value = charValue;
    }
  }
}
